import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";

import { CsvFileKind } from "../../../define/CsvFileKind";
import { MansionKind } from "../../../define/MansionKind";
import NormalGameManager from "../../manager/NormalGameManager";
import MansionBuildDataManage from "./build/MansionBuildDataManage";
import ChildDataManage from "./child/ChildDataManage";
import MansionData from "./MansionData";
import WifeDataManage from "./wife/WifeDataManage"
import utilsModel from "../../../../engines/libs/utilsModel";
import { FileKind } from "../../../define/FileKind";
import { MessageEventKind } from "../../../define/MessageEventKind";


export default class MansionDataManage {

    mansionData = new MansionData();
    wifeDataManage = new WifeDataManage();
    childDataManage = new ChildDataManage();
    mansionBuildDataManage = new MansionBuildDataManage();
 
    loadLocationData() {
        this.wifeDataManage.loadLocationData();
        this.childDataManage.loadLocationData();
        this.mansionData.loadLocalData();
        this.mansionBuildDataManage.loadLocationData();

        this.loginDataDispose();
    }

    saveAllLocationData() {
        this.wifeDataManage.saveAllLocationData();
        this.childDataManage.saveAllLocationData();
        this.mansionData.saveLocalData();
        this.mansionBuildDataManage.saveAllLocationData();
    }

    /**
     * 登录数据处理
     */
    loginDataDispose() {
        let curTime = data_control.getCurrDateDayString();
        if (curTime != this.mansionData.lastCardRefreshTime) {
            this.mansionData.lastCardRefreshTime = curTime;
            this.refreshCardList();
        }

        this.statisticsCosts();

        this.mansionDataDispose();
    }

    statisticsCosts() {
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.WIFE);
        if (!csvInfos) {
            console.error(`未找到表格 WIFE`);
            return;
        }
        let mansionData = this.mansionData;
        let wifeData = this.wifeDataManage.wifeData;
        let childData = this.childDataManage.childData;

        mansionData.costGold = 0;
        childData.lists.forEach((v)=> {
            mansionData.costGold += v.everyDayCost;
        });

        let title = csvInfos.title;
        wifeData.lists.forEach((v, key)=> {
            let info = csvInfos[key];
            if (!info) {
                console.error(`未找到 WIFE 信息 key = ` + key);
                return;
            }
            mansionData.costGold += Number(info[title.costs]);
        });
        mansionData.saveLocalData();
    }

    refreshCardList() {
        this.mansionData.cardList = [];
        this.mansionData.useCardList = [];
            
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.MANSION_CARD);
        if (!csvInfos) {
            console.error('未找到 MANSION_CARD 信息');
            return;
        }
        let title = csvInfos.title;

        let totalWeight = 0;
        let weightList: number[][] = [];
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let info = csvInfos[i];
            let appear_odds = Number(info[title.appear_odds]);
            totalWeight += appear_odds;

            weightList.push([totalWeight, Number(i)]);
        }

        for (let c = 0; c < 4; c++) {
            let randomW = data_control.randomNumInt(0, totalWeight);
            for (let i = 0; i < weightList.length; i++) {
                if (randomW <= weightList[i][0]) {
                    let cardId = weightList[i][1];
                    this.mansionData.cardList.push(cardId);
                    break;
                }
            }
        }
        this.mansionData.saveLocalData();
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {
        this.wifeDataManage.dayDataDispose();
        this.childDataManage.dayDataDispose();
        this.mansionBuildDataManage.dayDataDispose();

        let gold = O1HD.getServices().userSrv.getCoins();
        let costGold = this.mansionData.costGold * 10000;
        let subGold = Math.min(costGold, gold);
        if (subGold > 0) {
            O1HD.getServices().userSrv.setCoins(-costGold, true);
            
            let hint = '府邸今日花费' + data_control.getNumberFormat(costGold);
            O1HD.getModules().uiControlModule.showMessageBox(hint);
        }

        if (costGold > gold) {
            NormalGameManager._instance.addOneWeChatTriggerLink('53');
        }

        O1HD.emit(MessageEventKind.EventName.REFRESH_MAINSION_MEMBER_DATA);
    }

    /**
     * 府邸数据处理
     */
    mansionDataDispose() {
        let childCount = 0; //this.childDataManage.ownChildCount(true);
        let curCapacity = this.mansionData.curCapacity;
        let wifeCount = 0; //this.wifeDataManage.ownWifeCount();
        // let uWifeCount = 0;
        let wifeData = this.wifeDataManage.wifeData;
        let childData = this.childDataManage.childData;
        let uWifeList: string[] = [];
        let uChildList: string[] = [];
        wifeData.lists.forEach((v, key)=> {
            if (v.state == MansionKind.WifeState.WIFE) {
                if (v.bEnterMansion) {
                    wifeCount++;
                } else {
                    uWifeList.push(key);
                }
            }
        });
        childData.lists.forEach((v, key)=> {
            if (v.bEnterMansion) {
                childCount++;
            } else {
                uChildList.push(key);
            }
        });

        if (uWifeList.length > 0) {
            let canAddCount = curCapacity - (childCount + wifeCount);
            canAddCount = Math.min(canAddCount, uWifeList.length);
            if ( canAddCount > 0 ) {
                for (let i = 0; i < canAddCount; i++) {
                    let v = wifeData.lists.get(uWifeList[i]);
                    if (!v) {
                        continue;
                    }
                    v.bEnterMansion = true;
                    wifeCount++;
                }
                wifeData.saveLocalData();
            }
        }
        if (uChildList.length > 0) {
            let canAddCount = curCapacity - (childCount + wifeCount);
            canAddCount = Math.min(canAddCount, uChildList.length);
            if ( canAddCount > 0 ) {
                for (let i = 0; i < canAddCount; i++) {
                    let v = childData.lists.get(uChildList[i]);
                    if (!v) {
                        continue;
                    }
                    v.bEnterMansion = true;
                    childCount++;
                }
                childData.saveLocalData();
            }
        }
    }

    /**
     * 获取子女阶段头像
     * @param bBoy 
     * @param stage 
     * @returns 
     */
    getChildStageHead(bBoy: boolean, stage: number) {
        let wName = 'girl_stage_head_icon';
        if (bBoy) {
            wName = 'boy_stage_head_icon';
        }

        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, wName);
        if (!info) {
            console.error(`未找到表格数据 MANSION ` + wName);
            return '';
        }
        let splits = utilsModel.splitLineFeed(info.value);
        let stageSplits = splits[stage];
        if (!stageSplits) {
            return '';
        }
        let iconLists = stageSplits.split(FileKind.ResParseType.SUB_ITEM);
        let idx = data_control.randomNumInt(0, iconLists.length-1);
        return iconLists[idx];
    }

    createChild(monsterId: string) {
        let mansionData = this.mansionData;
        let childDataManage = this.childDataManage;
        let childData = childDataManage.childData;

        childData.maxId++;
        let childId = childData.maxId + '';
        let data = childData.createItem(childId);
        data.bBoy = data_control.isHitProbability(0.5) ? true : false;
        data.icon = this.getChildStageHead(data.bBoy, data.stage);
        data.motherId = monsterId;

        let wName = 'cost_list_son';
        if (!data.bBoy) {
            wName = 'cost_list_girl';
        }

        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, wName);
        if (!info) {
            console.error(`未找到表格数据 MANSION ` + wName);
        } else {
            let splits = utilsModel.splitLineFeed(info.value);
            let idx = data_control.randomNumInt(0, splits.length - 1);
            data.everyDayCost = Number(splits[idx]);
        }
        childData.saveLocalData();
        mansionData.costGold += data.everyDayCost;
        mansionData.saveLocalData();
        return data;
        // let _pparent: MansionsMemberLayer = this._carryData._pparent;
        // _pparent.refreshState();
    }

    /** 
     * 数据兼容
     */
    dataCompatibility() {
        this.wifeDataManage.dataCompatibility();
    }
}
